import React from 'react';

const Bookings = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
            <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-4">Bookings</h1>
            <p className="text-gray-600 dark:text-gray-400">Your bookings will appear here. This is a placeholder.</p>
        </div>
    );
};

export default Bookings;
